import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { useNavigate, useOutletContext } from 'react-router';
import { useIotsApi } from '../../../contexts/iotsApi';
import { useLanguage } from '../../../contexts/language';
import { disableNavigationGuard } from '../../../hooks/useNavigationGuard';
import CrewForm from './CrewForm';
import { CrewTemplateContext } from './types';
import useApiErrorMessageGetter from '../../../hooks/useApiErrorMessage';

const CreateCrewPage = () => {
  const { createCrewMember } = useIotsApi();
  const { t } = useLanguage();
  const mutation = useMutation({ mutationFn: createCrewMember });
  const { enqueueSnackbar } = useSnackbar();
  const getErrorMessage = useApiErrorMessageGetter();
  const navigate = useNavigate();
  const { setDisplayedCrewMemberFullName } =
    useOutletContext<CrewTemplateContext>();

  return (
    <CrewForm
      crewMember={null}
      isLoading={mutation.isPending}
      onCrewMemberNameChange={setDisplayedCrewMemberFullName}
      onSubmit={values => {
        mutation.mutate(values, {
          onSuccess: id => {
            enqueueSnackbar({
              variant: 'success',
              message: t('content.crew-creation-success'),
            });
            void disableNavigationGuard(() => navigate(`/admin/crew/${id}`));
          },
          onError: error => {
            enqueueSnackbar({
              variant: 'error',
              message: getErrorMessage(
                error,
                `${t('content.crew-creation-error')}`,
              ),
            });
            mutation.reset();
          },
        });
      }}
      onCancel={() => void navigate('/admin/crew')}
    />
  );
};

export default CreateCrewPage;
